// extracted by mini-css-extract-plugin
export default {"grid-container":"project-grid_grid-container__Ips5V"};